import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { InfoPagina } from '@hm_app/@core/models/info';


@Component({
    selector: 'informativa',
    templateUrl: './informativa.component.html',
    styleUrls: ['./informativa.component.scss'],
})
export class InformativaComponent implements OnInit {
    current_info: InfoPagina;

    constructor(private activeModal: NgbActiveModal, private hmService: HappyMammaService) {

    }

    async ngOnInit() {
        const pagine = await this.hmService.getAll<InfoPagina>(InfoPagina, { pagina: 'info_privacy' }).toPromise();

        if (pagine.length > 0) {
            this.current_info = pagine[0];
        }
        // console.log(this.current_info);
        // console.log(pagine);
    }

    closeModal() {
        this.activeModal.close();
    }

}
